export default __webpack_public_path__ + "static/media/photo_mathilde.e7f06e62.png";